/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 11:27:51
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-07 20:50:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/common.ts
 */

import { EnumLinkType } from 'src/types/common/linkType';

export enum EnumCollapseId {
  backgroundStyle = 'saleChannelContentProfilePageBackgroundStyle',
  policy = 'saleChannelContentProfilePagePolicy',
  management = 'profileContentManagement',
}

export enum ModuleType {
  FeaturedProduct = 'FeaturedProduct',
  Edm = 'Edm',
}

export interface defaultLinkTo {
  linkType: EnumLinkType;
  uuid: string;
  label: string;
  action: string;
}

export interface PolicyType {
  draggableId: string;
  title: string;
  linkTo: defaultLinkTo;
}

export const generateBackgroundStyle = () => {
  return {
    image: null,
    backgroundColor: '#000000',
    primaryColor: '#000000',
    tabColor: '#000000',
    textColor: '#ffffff',
  };
};

export const generateProfileContentManagement = () => {
  return {
    subscriptionBuy: false,
    voucher: false,
    thirdPartyLogin: false,
    myAddress: false,
  };
};
